export default {
	data() {
		return {
			moduleName: 'streamProfiles',
			detailPageRouteName: 'streamProfileDetail',
			entity: {
				name: null,
				code: null,
				weight: null,
				id_codec: '',
				id_operator: null,
				bitrate: null,
				shaping_bitrate: null,
				interlaced: false,
				thumbnail: false,
				resolution: {
					width: null,
					height: null
				},
				sync_group: '',
				mux_mask: null,
				read_scte_marks: false,
				backend_config: null,
				allowed_audio_codecs: null,
				vod: false,
			},
			updateFields: [
				'name',
				'code',
				'weight',
				'id_codec',
				'id_operator',
				'resolution',
				'interlaced',
				'bitrate',
				'shaping_bitrate',
				'sync_group',
				'thumbnail',
				'mux_mask',
				'share_extra_tracks',
				'read_scte_markers',
				'backend_config',
				'allowed_audio_codecs',
				'vod',
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		_resetFields() {
			this.$refs['streamprofileformref'].validateStreamProfileFormRequiredFields()
			this.$refs['streamprofilemetadataformref'].validateStreamProfileFormRequiredFields();
			this.$refs['streamprofileformref'].$refs['nameref'].setTouched(false)
			this.$refs['streamprofileformref'].$refs['coderef'].setTouched(false)
			this.$refs['streamprofileformref'].$refs['weightref'].setTouched(false)
		},
		processErrorMessage(error) {
			let errorMessage = null;
			this.$refs['streamprofileformref'].validateStreamProfileFormRequiredFields()
			this.$refs['streamprofilemetadataformref'].validateStreamProfileFormRequiredFields();

			this._.forEach(error['validation_errors'], function (message) {
				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název profilu musí být unikátní.');
					this.$refs['streamprofileformref'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
				} else if (message.match("^Code \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Kód profilu musí být unikátní.');
					this.$refs['streamprofileformref'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód není unikátní'));
				} else if (message === "Code can contains only alphanumeric characters, dash and underscore!") {
					errorMessage = this.$gettext("Kód smí obsahovat pouze znaky [a-z0-9-_].");
					this.$refs['streamprofileformref'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód smí obsahovat pouze znaky [a-z0-9-_].'));
				} else if (message === "Bitrate value must be number.") {
					this.$refs['streamprofilemetadataformref'].$refs['bitrateref'].setForcedInvalid(true, this.$gettext('Musí být vyplněna číselná hodnota.'));
				} else if (message === "Width value must be number.") {
					this.$refs['streamprofilemetadataformref'].$refs['widthref'].setForcedInvalid(true, this.$gettext('Musí být vyplněna číselná hodnota.'));
				} else if (message === "Height value must be number.") {
					this.$refs['streamprofilemetadataformref'].$refs['heightref'].setForcedInvalid(true, this.$gettext('Musí být vyplněna číselná hodnota.'));
				} else if (message.includes('Weight')) {
					this.$refs['streamprofileformref'].$refs['weightref'].setForcedInvalid(true, this.$gettext('Musí být číselná hodnota v rozmezí 0 až 10000.'));
				} else if (message === "At least one of the symbol 'a' or 'v' must be set") {
					errorMessage = this.$gettext("V muxovací masce musí být alespoň jeden ze symbolů 'a' nebo 'v'");
				} else if (message === "A streamProfile with 'share_extra_track' enabled already exists in same sync_group") {
					errorMessage = this.$gettext("Již existuje jiný profil streamu ve stejné synchronizační skupině se sdílenými oddělenými stopami.");
				} else if (message === "There is already another stream profile with the active flag 'read SCTE markers' in this sync group") {
					errorMessage = this.$gettext("Již existuje jiný profil streamu ve stejné synchronizační skupině s aktivní volbou 'Číst SCTE35 značky'.");
				} else if (message === "Allowed audio codecs must be null or not empty string.") {
					errorMessage = this.$gettext("Seznam povolených audio kodeků musí být neprázdný řetězec id kodeků oddělených čárkami.");
				}else {
					errorMessage = message;
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		},
		_beforeCreateEntityActions(params = null) {
			if (Number(params['id_operator']) === 0) {
				params['id_operator'] = null
			}
			return params
		},
	},
	computed: {
		operatorIdComputed: {
			get() {
				return this.entity.id_operator
			},
			set(newValue) {
				this.entity.id_operator = newValue
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/streamProfiles/mixins/streamProfiles.js